import { api, authTokenStore } from '../lib/api'

export const authService = {
  async register(payload) {
    const data = await api.post('/v1/auth/register', payload)
    authTokenStore.set(data.token)
    return data.user
  },
  async login(payload) {
    const data = await api.post('/v1/auth/login', payload)
    authTokenStore.set(data.token)
    return data.user
  },
  async me() {
    const data = await api.get('/v1/me')
    return data.user
  },
  async updateProfile(payload) {
    const data = await api.patch('/v1/me', payload)
    return data.user
  },
  logout() {
    authTokenStore.clear()
  }
}
